export default __webpack_public_path__ + "static/media/participatingTeam2.3a7cd19d.png";